<template>
    <div class="popup">
        <div class="popup-content" :class="{ 'is-loading': isLoading }">
            <button class="popup-close" @click.prevent="handleClosePopup"></button>

            <div class="popup-scrollable">
                <h2>Objecten importeren</h2>
                <p>Selecteer het XLSX bestand om te importeren. <a :href="`${publicPath}files/tbexpertise-import.xlsx`">Download voorbeeld XLSX</a>.</p>

                <form method="post" @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)">

                    <div class="alert alert-danger" v-if="error" v-text="error"></div>
                    <div class="alert alert-success" v-if="success" v-text="success"></div>

                    <div class="form-group">
                        <label class="form-label" for="file">XLSX Bestand</label>
                        <input type="file" name="file" id="file" ref="file" class="form-control" @change="handleFileUpload" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                    </div>

                    <input type="submit" value="Objecten importeren" class="btn btn-primary mt-2">
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import { IMPORT_PROJECTS } from '@/store/modules/objects';

	export default {
		props: ['project'],

		mounted () {
		},

		data () {
			return {
				publicPath: process.env.BASE_URL,
				error: null,
				success: null,
				isLoading: false,
				file: null,
			}
		},

		computed: {},

		methods: {
			handleFileUpload () {
				this.file = this.$refs.file.files[0]
			},

			handleClosePopup () {
				this.$emit('togglePopup')
			},

			prepareFormData () {
				let object = new FormData()

				object.append('file', this.file)

				return object
			},

			onSubmit () {
				this.isLoading = true

				this.$store.dispatch(IMPORT_PROJECTS, {
					project: this.project,
					data: this.prepareFormData(),
				}).then(() => {
					this.success = 'De objecten zijn succesvol geimporteerd.';
					location.reload();
				}).catch(() => {
					alert('Er is een fout opgetreden. Probeer het later opnieuw.');
				})

				console.log({
					file: this.file,
					project: this.project,
				})
			},
		},
	}
</script>